import Alert from '@cobliteam/ui/components/Alert';

/**
 * `navigator.clipboard.writeText` rejects on a denied permission or an unfocused
 * document. Swallowing that here keeps callers from producing an unhandled
 * rejection, and the boolean matches `CopyButton`'s `(text) => Promise<boolean>`
 * contract so its copied state only flips on an actual write.
 */
const copyToClipboard = async (text: string) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
};

/**
 * Shared by the toolbar menu item and the "Meus dados" panel, which both copy the
 * session JWT and previously reported success before the write had resolved.
 */
const copyJwtToken = async (jwtToken: string | null | undefined) => {
  if (!jwtToken) {
    Alert.error('JWT Token indisponível.');
    return false;
  }

  const copied = await copyToClipboard(jwtToken);
  if (copied) Alert.success('JWT Token copiado!');
  else Alert.error('Não foi possível copiar o JWT Token.');

  return copied;
};

export { copyJwtToken, copyToClipboard };
